import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';

import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import RequestChurnButtonPicker from './RequestChurnButtonPicker';


const useStyles = buildUseStyles('Template', ((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    borderRadius: theme.radius.md,
    maxWidth: theme.dimensions.xl,
  },
  title: {
    textAlign: 'left',
  },
  body: {
    textAlign: 'left',
  },
  buttonContainer: {
    textAlign: 'center',
  },
  textLink: {
    color: theme.palette.facet,
  },
})));

const Membership = ({
  collection,
}) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      <Paper className={classes.paper}>
        <Title className={classes.title} text={'Client Support'} />
        <br />
        <BodyText className={classes.body} text={'Having an issue? We’re here to help! Share a few details about the issue you’re having and we’ll be in touch.'} />
        <br />
        <Box className={classes.buttonContainer}>
          <RoundedButton
            size={'sm'}
            fullWidth
            onClick={() => window.open('mailto:support@facetwealth.com', '_blank')}
          >
            {'Contact Client Support'}
          </RoundedButton>
        </Box>
      </Paper>
      <Paper className={classes.paper}>
        <Title className={classes.title} text={'Membership'} />
        <br />
        <RequestChurnButtonPicker collection={collection} />
      </Paper>
    </Box>
  );
};

Membership.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default Membership;
